import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import SvgFilterIcon from '../SvgFilterIcon/SvgFilterIcon';
import * as S from './CellFilter.style';

interface Props {
  onVisibilityChange: (isVisible: boolean) => void;
  children: (toggleIsVisible: () => void) => ReactNode;
  isFilterActive: boolean;
}

const CellFilter = ({ onVisibilityChange, children, isFilterActive }: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleIsVisible = () => setIsVisible((prevIsVisible) => !prevIsVisible);

  useEffect(() => {
    onVisibilityChange(isVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <S.PopoverCell
      placement="bottom"
      open={isVisible}
      onOpenChange={(newIsVisible) => setIsVisible(newIsVisible)}
      content={isVisible ? children(toggleIsVisible) : ''}
      withButton
      data-testid="popover-cell-filter"
    >
      <SvgFilterIcon isFilterActive={isFilterActive} />
    </S.PopoverCell>
  );
};

export default CellFilter;
